import { combineReducers } from 'redux';

import generalReducer from './data/general';

export default combineReducers({
  data: combineReducers({
    general: generalReducer,
  }),
});
